export default __webpack_public_path__ + "static/pole-emploi-d7c2402ef307e4599f9175181444462a.png";